<template>
  <div class="home container">
    <div>
      <van-sticky>
        <van-nav-bar>
          <template #title>
            <a href="/">
              <div style="display: flex;">
                <img src="/image/jkn.png" style="max-height: 40px;" alt="">
                <div style="font-weight: bold;font-size:1.9em;color:black;"></div>
              </div>
            </a>
          </template>
        </van-nav-bar>
      </van-sticky>
    </div>
    <div style="margin-bottom : 70px;">
      <img style="max-width : 100%;width : 100%;" src="/img/banner.jpeg" />
      <van-cell>
        <h2>SISTEM TIKET</h2>
        <h2>FILM JEJAK KHILAFAH DI NUSANTARA</h2>
        <p>Silakan isi form berikut untuk menonton FILM JKDN</p>
      </van-cell>
      <div v-if="register == false">
        <van-cell> <small for="">Masukan No.WA</small>
          <input name="phone" v-model="phone" type="text" placeholder="081351892323" class="van-field__control"></van-cell>
        <van-cell>
          <van-button @click="login()" type="primary" block>Masuk</van-button>
        </van-cell>
    <van-cell>
          <p>Belum Punya Akun? <span style="margin-left : 10px;" ><van-button @click="register = true">DAFTAR SEKARANG</van-button></span></p>
    </van-cell>
      </div>
      <div v-if="register">
        <van-cell v-if="peserta.id"> <small for="">Nama</small>
          <input type="text" readonly name="nama" :value="maskData(peserta.nama)" placeholder="Muhammad" class="van-field__control"></van-cell>
             <van-cell v-else> <small for="">Nama</small>
          <input type="text" name="nama" v-model="peserta.nama" placeholder="Muhammad" class="van-field__control"></van-cell>
        <van-cell> <small for="">No.WA</small>
          <input type="text" name="phone" v-model="peserta.phone" placeholder="0813435343434" class="van-field__control"></van-cell>
        <van-cell v-if="peserta.id"> <small for="">Email</small>
          <input readonly type="text" name="email" :value="maskData(peserta.email)" placeholder="muhammad@email.com" class="van-field__control"></van-cell>
             <van-cell v-else> <small for="">Email</small>
          <input type="text" name="email" v-model="peserta.email" placeholder="muhammad@email.com" class="van-field__control"></van-cell>
        <van-cell> <small for="">Provinsi</small>
          <select name="pekerjaan" v-model="peserta.alamat" style="width : 100%;height : 3.4em;font-size:14px;padding : 10px;border-color:white;"
           id="">
            <option value="" disabled>Pilih Provinsi</option>
            <option v-for="(item,index) in Provinsi" :key="index" :value="item">{{item}}</option>
          </select>
        </van-cell>
         <van-cell> <small for="">Jenis Kelamin</small>
          <select name="pekerjaan" style="width : 100%;height : 3.4em;font-size:14px;padding : 10px;border-color:white;"
            v-model="peserta.gender" id="">
            <option value="semua" disabled>Pilih Jenis Kelamin</option>
            <option value="laki-laki">Laki-Laki</option>
            <option value="perempuan">Perempuan</option>
          </select>
        </van-cell>
        <van-cell>
            <van-notice-bar text="Room Laki-laki dipisah dengan Room Perempuan" left-icon="volume-o" />
        </van-cell>
        <van-button @click="saveData()" type="primary" block>{{signup_text}}</van-button>
      </div>



    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
import axios from 'axios'
  export default {
    name: 'Home',
    data: () => ({
      phone: '',
      signup_text: 'DAFTAR',
      peserta: {
        gender : 'semua'
      },
      Provinsi: [
        'Aceh',
        'Sumatera Utara',
        'Sumatera Barat',
        'Riau',
        'Jambi',
        'Sumatera Selatan',
        'Bengkulu',
        'Lampung',
        'Kepulauan Bangka Belitung',
        'Kepulauan Riau',
        'Daerah Khusus Ibukota Jakarta',
        'Jawa Barat',
        'Jawa Tengah',
        'Daerah Istimewa Yogyakarta',
        'Jawa Timur',
        'Banten',
        'Bali',
        'Nusa Tenggara Barat',
        'Nusa Tenggara Timur',
        'Kalimantan Barat',
        'Kalimantan Tengah',
        'Kalimantan Selatan',
        'Kalimantan Timur',
        'Kalimantan Utara',
        'Sulawesi Utara',
        'Sulawesi Tengah',
        'Sulawesi Selatan',
        'Sulawesi Tenggara',
        'Gorontalo',
        'Sulawesi Barat',
        'Maluku',
        'Maluku Utara',
        'Papua',
        'Papua Barat'
      ],
      register: false,
     
    }),
    components: {},
    mounted()
    {
          var peserta = localStorage.getItem('peserta');
            if(peserta)
            {
             this.$router.push('/waiting-room')
            }

            this.peserta.random_key = this.makeid(16);
            
                this.peserta.alamat = '';
                   this.peserta.event_id = 1;
    },
    methods:{
      maskData(string)
      {
        return '*****'+string.substr(5,string.length)
      },
      saveData()
      {

        axios.post(this.$parent.endpoint+'/save-peserta',this.peserta).then((response)=>{
            localStorage.setItem('peserta',JSON.stringify(response.data))
           this.$router.push('/waiting-room');
           
        })
      },
          makeid(length) {
                var result           = '';
                var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for ( var i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
                },
      login()
      {
        axios.post(this.$parent.endpoint+'/check-peserta',{phone : this.phone, event_id : 1}).then(response=>{
          if(response.data)
          {
            this.peserta = response.data;
            if(this.peserta.alamat)
            {
              localStorage.setItem('peserta',JSON.stringify(this.peserta))
              this.$router.push('/waiting-room');
            }else{
               this.peserta = response.data;
               this.register = true;
               this.signup_text = 'Simpan Data'
               this.peserta.alamat = '';
               delete this.peserta.created_at;
               delete this.peserta.updated_at;

            }
            
          }else{
            this.register = true;
          }
         
        },()=>{
                this.peserta.phone = this.phone;
             
                
            this.register = true;
        })
      }
    }
  }
</script>